import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/UploadSubCategoryMaster';
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const UploadSubCategoryMaster = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Sub Category Master - Upload</h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

  </Container>
);

UploadSubCategoryMaster.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(UploadSubCategoryMaster);
